import { finalize, Observable, OperatorFunction } from 'rxjs';
import { LoadingService } from '../services/loading.service';

export function withLoading<T>(
  loadingService: LoadingService,
  key: string
): OperatorFunction<T, T> {
  return (source: Observable<T>) => {
    loadingService.setLoading(key, true);
    return source.pipe(finalize(() => loadingService.setLoading(key, false)));
  };
}
